import * as React from 'react';

import { createIcon } from '../Icon';
export const FilterIcon = createIcon(
  <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />,
  'FilterIcon'
);
